@use "@fukuri-admins/ui/layout" as *;

// button の UA スタイルをリセットしつつ共通スタイルを定義
.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: borderRadius('lg');
  border: 1px solid transparent;
  cursor: pointer;
  appearance: none;
  font-family: inherit;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px border('Focus');
    overflow: hidden;
  }
}

// Variant: Default（白背景 + ボーダー）
.variantDefault {
  background-color: background('Primary');
  border-color: border('Quaternary');
  color: text('High');

  &:hover:not(:disabled):not(.selected) {
    background-color: background('Secondary');
  }

  &:disabled {
    background-color: background('Tertiary');
    border-color: border('Quaternary');
    color: text('Disabled');
    cursor: not-allowed;
  }
}

// Variant: Secondary（グレー背景、ボーダーなし）
.variantSecondary {
  background-color: background('Secondary');
  color: text('High');

  &:hover:not(:disabled):not(.selected) {
    // Figma 仕様: Secondary 背景に白 20% オーバーレイ
    background-image: linear-gradient(
      background('Overlay_Wh_20'),
      background('Overlay_Wh_20')
    );
    background-color: background('Secondary');
  }

  &:disabled {
    background-color: background('Tertiary');
    color: text('Disabled');
    cursor: not-allowed;
  }
}

// Selected（黒背景・白テキスト）
.selected {
  background-color: background('Gray_Darken');
  border-color: border('Gray_Darken');
  color: text('White');

  // .svgIcon の color: text('High') を上書きし、ボタンの color: text('White') を svg に継承させる
  svg {
    color: currentColor;
  }
}

// isMulti + selected 時のチェックアイコンとのギャップ
.withIcon {
  gap: spacing('4');
}

// Size: sm
.sm {
  padding: spacing('6') spacing('8');

  @include typography('Jp/12_W3');
}

// Size: md
.md {
  padding: spacing('6') spacing('12');

  @include typography('Jp/14_W3');
}

// Size: lg
.lg {
  padding: spacing('6') spacing('16');

  @include typography('Jp/16_W3');
}
